import { render } from "./additional-guest-memory-overhead-ratio.vue?vue&type=template&id=6546c98a"
import script from "./additional-guest-memory-overhead-ratio.vue?vue&type=script&lang=js"
export * from "./additional-guest-memory-overhead-ratio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__